export const formatLabel = (value: number, suffix: string): string => {
  if (value === undefined) {
    return "mixed"
  }
  return `${Math.round(value)} ${suffix}`
}
